import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Password from "../pages/Authentication/ForgetPassword";

import UserProfile from "../pages/Authentication/user-profile";
import ManageParent from "../pages/ManageParent";
import ManageChild from "../pages/manageChild";
import ManageTeacher from "../pages/ManageTeacher";
import ManageSites from "../pages/ManageSites";
import ManageTimetable from "../pages/ManageTimetable";
import Settings from "../pages/Settings";
import ManagePackage from "../pages/managePackage";
import ManageProgram from "../pages/manageProgram";
import ManageProgramUnpaid from "../pages/manageProgramUnpaid";
import ManageSwap from "../pages/ManageSwap";
import ManageSurvey from "../pages/ManageSurvey";
import ManageCoupon from "../pages/ManageCoupon";
import ManageCohort from "../pages/manageCohort";
import ManageTestimonial from "../pages/ManageTestimonial";
import ManagePartner from "../pages/ManagePartner";
import ParnerDashboard from "../pages/ManagePartner/PartnerDashboard";
import PartnerParent from "../pages/ManagePartner/PartnerParent";
import PartnerChild from "../pages/ManagePartner/PartnerChild";
import PartnerProgram from "../pages/ManagePartner/PartnerProgram";
import PromoProgram from "../pages/managePromo/PromoProgram";
import PromoChild from "../pages/managePromo/PromoChild";
import PromoParent from "../pages/managePromo/PromoParent";
import PromoDashboard from "../pages/managePromo/PromoDashboard";
import ManagePartnerProgram from "../pages/managePartnerPrograms/ManagePartnerProgram";
import ManagePromo from "../pages/managePromo";
import ManagePromoProgram from "../pages/managePromoProgram/ManagePromoProgram";
import PromoTimeSlot from "../pages/managePromo/PromoTimeSlot";
import ManageBlog from "../pages/ManageBlog";
import ManageTeacherView from "../pages/manageTeacherView";
import ManageReport from "../pages/ManageReport";

import ManageAudit from "../pages/ManageLogs";
import ManageAutoAssignment from "../pages/ManageAutoAssignment";
import ManageFaculty from "../pages/ManageFaculty";
import ManageActivities from "../pages/ManageActivities";
import ManageAdmin from "../pages/manageAdmin";

const userRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard />, roleType: "admin" },

  { path: "/manage-parent", component: <ManageParent />, roleType: "admin" },

  { path: "/manage-child", component: <ManageChild />, roleType: "admin" },

  { path: "/manage-teacher", component: <ManageTeacher />, roleType: "admin" },

  { path: "/manage-sites", component: <ManageSites />, roleType: "admin" },

  { path: "/manage-program", component: <ManageProgram/>, roleType: "admin" },

  { path: "/manage-program-unpaid", component: <ManageProgramUnpaid/>, roleType: "admin" },

  { path: "/manage-cohort", component: <ManageCohort/>, roleType: "admin" },

  { path: "/manage-timetable", component: <ManageTimetable />, roleType: "admin" },

  { path: "/manage-package", component: <ManagePackage/>, roleType: "admin" },

  { path: "/manage-swap", component: <ManageSwap/>, roleType: "admin" },

  { path: "/manage-survey", component: <ManageSurvey/>, roleType: "admin" },

  { path: "/manage-coupon", component: <ManageCoupon/>, roleType: "admin" },

  { path: "/manage-partner", component: <ManagePartner/>, roleType: "admin" },

  { path: "/manage-promo", component: <ManagePromo/>, roleType: "admin" },

  { path: "/manage-teacher-view", component: <ManageTeacherView/>, roleType: "admin" },

  { path: "/manage-auto-assignment", component: <ManageAutoAssignment/>, roleType: "admin" },

  { path: "/manage-activities", component: <ManageActivities/>, roleType: "admin" },

  { path: "/manage-report", component: <ManageReport />, roleType: "admin" },
  
  { path: "/manage-testimonial", component: <ManageTestimonial/>, roleType: "admin" },

  { path: "/settings", component: <Settings />, roleType: "admin" },

  { path: "/manage-partner-program", component: <ManagePartnerProgram />, roleType: "admin" },

  { path: "/manage-promo-program", component: <ManagePromoProgram />, roleType: "admin" },

  { path: "/view-audit", component: <ManageAudit />, roleType: "admin" },

  //profile
  { path: "/profile", component: <UserProfile />, roleType: "admin" },

  { path: "/manage-blog", component: <ManageBlog />, roleType: "admin" },

  { path: "/manage-admin", component: <ManageAdmin />, roleType: "admin" },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: <Navigate to="/dashboard" />, roleType: "admin" },
];

const authRoutes = [
  //authencation page
  { path: "/auth/logout", component: <Logout /> },
  { path: "/auth/login", component: <Login /> },
  { path: "/auth/forgot", component: <Password /> },
];

const facultyRoutes = [
  //faculty page
  { path: "/faculty", component: <ManageFaculty />, roleType: "faculty" },
];

const subAdminRoutes = [
  { path: "/manage-secondary-activities", component: <ManageActivities />, roleType: "subadmin" },
];

const partnerRoutes = [
  //partner page
  { path: "/partner/dashboard/:id", component: <ParnerDashboard />, roleType: "admin" },
  { path: "/partner/manage-parent/:id", component: <PartnerParent />, roleType: "admin" },
  { path: "/partner/manage-child/:id", component: <PartnerChild />, roleType: "admin" },
  { path: "/partner/manage-program/:id", component: <PartnerProgram />, roleType: "admin" },
];

const promoRoutes = [
  //promo page
  { path: "/promo/dashboard/:id", component: <PromoDashboard />, roleType: "admin" },
  { path: "/promo/manage-parent/:id", component: <PromoParent />, roleType: "admin" },
  { path: "/promo/manage-child/:id", component: <PromoChild />, roleType: "admin" },
  { path: "/promo/manage-program/:id", component: <PromoProgram />, roleType: "admin" },
  { path: "/promo/manage-time/:id", component: <PromoTimeSlot />, roleType: "admin" },
];

export { userRoutes, authRoutes, partnerRoutes, promoRoutes, facultyRoutes, subAdminRoutes };
